import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AppState } from 'src/app/reducers';
import { Feed } from 'src/app/core/models/core.models';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectFeed } from 'src/app/core/reducers';

// used as panel wrapper for query editor
@Component({
  selector: 'app-feed-query-editor',
  templateUrl: './feed-query-editor.component.html',
  styleUrls: ['./feed-query-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FeedQueryEditorComponent implements OnInit {
  //
  feed$: Observable<Feed>;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.feed$ = this.store.select(selectFeed);
  }
}
